import { Navigate, useLocation } from 'react-router-dom';
import { trpc } from '@/trpc/client';
import { useLocationId } from '@/hooks/useLocationId';

/**
 * Redirects from "/" to "/location/:slug/" using the user's effective location.
 * Shown briefly on login or when navigating to the bare root.
 */
export function LocationRedirect() {
  const effectiveLocationId = useLocationId();
  const location = useLocation();
  const { data: loc } = trpc.location.getById.useQuery(
    { id: effectiveLocationId! },
    { enabled: !!effectiveLocationId }
  );

  if (!loc) return null; // Loading

  return <Navigate to={`/location/${loc.slug}${location.search}`} replace />;
}
